import { useEffect } from 'react';
import $ from 'jquery';
import { dispatch, select } from '@wordpress/data';
import { PAYONEER_STORE_KEY } from '../../store/index';

/**
 * @see https://developer.woocommerce.com/2022/10/06/how-the-checkout-block-processes-an-order/
 * @see https://developer.woocommerce.com/docs/cart-and-checkout-payment-method-integration-for-the-checkout-block/#3-props-fed-to-payment-method-nodes
 */
export const Component = function (
	{
		activePaymentMethod,
		eventRegistration,
		componentName,
		paymentMethodData,
		canMakePayment,
		initPayoneerComponents,
		rebootPayoneer,
		payWithPayoneer,
	}
) {
	const { onPaymentSetup, onCheckoutSuccess, onCheckoutFail } = eventRegistration;

	/**
	 * Ping the SDK when we see the light of day
	 */
	useEffect( () => {
		initPayoneerComponents();
	}, [] );

	useEffect( () => {
		return onCheckoutSuccess( ( { orderId, processingResponse } ) => {
			dispatch( PAYONEER_STORE_KEY ).setOrderId( orderId );
			dispatch( PAYONEER_STORE_KEY ).setLongIdToCharge(
				processingResponse?.paymentDetails?.longId
			);

			// Apple Pay already fired pay() inside the click gesture; only cards pay here.
			if ( ! select( PAYONEER_STORE_KEY ).isApplePaySelected() ) {
				payWithPayoneer();
			}

			// Block the checkout form while the WebSDK handles 3DS / APM redirect.
			// The never-settling promise keeps isAfterProcessing true, which keeps
			// the button spinner via waitingForProcessing. blockUI on the form
			// prevents interaction with the fields behind the 3DS modal.
			// On success the browser navigates away; on failure
			// blockCheckout.js handles recovery via location.reload().
			const $form = $( 'form.wc-block-checkout__form' );
			if ( $form.length && $.fn.block ) {
				$form.block( {
					message: null,
					overlayCSS: {
						background: '#fff',
						opacity: 0.6,
					},
				} );
			}

			return new Promise( () => {} );
		} );
	}, [] );

	useEffect( () => {
		return onCheckoutFail( () => {
			dispatch( PAYONEER_STORE_KEY ).setLongIdToCharge( null );
			rebootPayoneer();
		} );
	}, [] );

	/**
	 * Enhance the payment data validation step.
	 * We need to validate that the LIST used in block checkout submit
	 * matches the one we will use for finalizing the transaction in the backend.
	 * Therefore, we pass additional metadata in this listener
	 */
	useEffect( () => {
		return onPaymentSetup( () => {
			const store = select( PAYONEER_STORE_KEY );
			const { isReady, isValid } = store.getActiveComponent();

			// Apple Pay collects payment in its own sheet, so let /checkout run on readiness alone.
			if ( isReady && ( isValid || store.isApplePaySelected() ) ) {
				return { type: 'success' };
			}

			return {
				type: 'failure',
				message: 'Invalid payment fields',
			};
		} );
	}, [ canMakePayment, onPaymentSetup, paymentMethodData ] );

	return <div
		className={`payment_method_${activePaymentMethod}`}
		data-component={componentName}
	></div>;
};
